module.exports = __webpack_public_path__ + "img/组 22@2x.81133243.png";